import React, { useEffect, useState } from "react"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { IPageResponse } from "../../../types/IPageResponse"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import InfiniteScroll from "react-infinite-scroll-component"
import { IInnRegistryDto } from "../../../types/inn/IInnRegistryDto"
import { ClientInnPopUpListItem } from "./ClientInnPopUpListItem"
import { IInnSuggestion } from "../../../types/inn/IInnSuggestion"
import Input from "@/ui/components/Input"
import Button from "@/ui/components/Button"

export const ClientInnPopUpList: React.FC<{ visible: boolean; setVisible: (visible: boolean) => void }> = ({
  visible,
  setVisible
}) => {
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [errors, setErrors] = useState<IErrorModel>()
  const [innList, setInnList] = useState<IPageResponse<IInnRegistryDto>>()
  const [inn, setInn] = useState<IInnRegistryDto>()
  const [showAddPanel, setShowAddPanel] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [page, setPage] = useState(0)

  useEffect(() => {
    if (page === 0) {
      fetchInnList()
    }
  }, [page])

  useEffect(() => {
    if (!inn?.inn) {
      setInn({ ...inn, name: "" })
      return
    }
    if (inn.inn.length !== 10 && inn.inn.length !== 12) return
    TrinityAPI.suggestInn(inn.inn, response => {
      if (response.status === 200) {
        const rsp: IInnSuggestion = response.data
        if (rsp.suggestions.length > 0)
          setInn({ ...inn, name: rsp.suggestions[0].value, address: rsp.suggestions[0].data.address.value })
        else setInn({ ...inn, name: "", address: "" })
      }
    })
  }, [inn?.inn])

  const fetchInnList = () => {
    TrinityAPI.getClientInnList(page, searchQuery, response => {
      if (response.status === 200) {
        const currentItems = page === 0 ? new Array<IInnRegistryDto>() : innList?.items || new Array<IInnRegistryDto>()
        setPage(page + 1)
        setInnList({
          ...innList,
          items: currentItems.concat(response.data.items),
          totalPages: response.data.totalPages
        })
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка загрузки реестра: " + response.data.message })
      }
    })
  }

  const submit = (forceInn?: IInnRegistryDto) => {
    const currentInn = forceInn || inn
    if (!currentInn) return
    TrinityAPI.createClientInn(currentInn, response => {
      if (response.status === 200) {
        setInn(undefined)
        setShowAddPanel(false)
        let currentItems = innList?.items || new Array<IInnRegistryDto>()

        if (currentItems.filter(i => i.inn === currentInn.inn).length > 0) {
          const newItems = innList?.items.map(i => {
            if (i.inn === currentInn.inn) {
              i.comment = currentInn.comment
            }
            return i
          })
          setInnList({ ...innList, items: newItems || [], totalPages: innList?.totalPages || 0 })
        } else {
          currentItems.unshift(currentInn)
          setInnList({ ...innList, items: currentItems, totalPages: innList?.totalPages || 0 })
        }
      } else {
        setModalMessage({ title: "Ошибка!", text: "" })
        setErrors(response.data)
      }
    })
  }

  const remove = (currentInn: string) => {
    if (!currentInn) return
    TrinityAPI.deleteClientInn(currentInn, response => {
      if (response.status === 200) {
        let newItems = innList?.items.filter(i => i.inn !== currentInn) || new Array<IInnRegistryDto>()
        setInnList({ ...innList, items: newItems, totalPages: innList?.totalPages || 0 })
      } else {
        setModalMessage({ title: "Ошибка!", text: "" })
        setErrors(response.data)
      }
    })
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      setPage(0)
    }
  }

  if (visible) {
    return (
      <section className="user-search-popup">
        <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} error={errors} />
        <div className="container-user-search">
          <button className="close-btn-card" onClick={() => setVisible(false)} />
          <div className="header-user-search-popup">
            <h3 className="heading-chapter">Реестр рублевых плательщиков</h3>
            <div className="flex-row-24">
              <Input
                type="search"
                placeholder="Введите название компании, ИНН или комментарий"
                onKeyDown={handleKeyDown}
                onChange={e => setSearchQuery(e.target.value)}
              />
              <Button onClick={() => setShowAddPanel(true)}>Добавить</Button>
            </div>
            {showAddPanel ? (
              <div className="add-new-form">
                <h3 className="heading-chapter">Добавить ИНН</h3>
                <div className="flex-row-24 flex-wrap-mobile">
                  <input
                    type="text"
                    className="input-form"
                    onChange={e => setInn({ ...inn, inn: e.target.value })}
                    value={inn?.inn}
                    placeholder="ИНН"
                  />
                  <input
                    type="text"
                    className="input-form"
                    placeholder="Название компании"
                    value={inn?.name}
                    onChange={e => setInn({ ...inn, name: e.target.value })}
                  />
                  <input
                    type="text"
                    name=""
                    id=""
                    className="input-form"
                    onChange={e => setInn({ ...inn, comment: e.target.value })}
                    value={inn?.comment}
                    placeholder="Комментарий"
                  />
                </div>
                <div className="flex-row-24">
                  <input type="submit" value="Добавить" className="btn" onClick={() => submit(undefined)} />
                  <button className="btn grey-btn" onClick={() => setShowAddPanel(false)}>
                    Отменить
                  </button>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="inn_wrapper">
            <div className="inn_header_list">
              <p className="four-card-text">ИНН</p>
              <p className="four-card-text">Название компании</p>
              <p className="four-card-text">Адрес</p>
              <p className="four-card-text">Комментарий</p>
              <p className="four-card-text">Статус</p>
            </div>
            <ul className="block-list-users">
              <InfiniteScroll
                next={fetchInnList}
                hasMore={page < (innList?.totalPages || 0)}
                loader={<>Загрузка...</>}
                dataLength={innList?.items.length || 0}
                className="message-list"
                style={{ listStyleType: "none" }}
              >
                {innList?.items.map((i, index) => (
                  <ClientInnPopUpListItem key={index.toString()} inn={i} remove={remove} />
                ))}
              </InfiniteScroll>
            </ul>
          </div>
        </div>
      </section>
    )
  } else {
    return <></>
  }
}
